document.addEventListener("DOMContentLoaded", function () {
  const vids = document.querySelectorAll("#mv .mv_video");
  if (vids.length < 2) return;

  // ロゴも動画と同期して切替
  const logos = document.querySelectorAll("#mv .mv_logo");

  // 重要: 自動再生ポリシー対策（属性があってもプロパティでも明示）
  vids.forEach((v) => {
    v.muted = true;
    v.playsInline = true;
    v.autoplay = true;
    try {
      v.load();
    } catch (e) {
      /* noop: preload failure can be ignored */
    }
  });

  let idx = 0;
  // 念のため再生開始（Safari/iOS対策）
  vids[0].play().catch(() => {});

  // 初期ロゴの状態を動画と同期
  if (logos.length) {
    logos.forEach((el, i) => {
      if (i === 0) {
        el.classList.add("is-active");
      } else {
        el.classList.remove("is-active");
      }
    });
  }

  const DURATION = 10000; // 10秒ごとに切替
  const FADE_MS = 2000; // CSSのフェード時間と揃える

  // フェード後に前動画を停止するためのタイマー
  let stopTimer = null;

  const switchTo = (nextIdx) => {
    const cur = vids[idx];
    const nxt = vids[nextIdx];
    if (!cur || !nxt) return;

    cur.classList.remove("is-active");
    nxt.classList.add("is-active");

    // ロゴの切替（数が合わない場合もインデックスで循環させる）
    if (logos.length) {
      const curLogo = logos[idx % logos.length];
      const nextLogo = logos[nextIdx % logos.length];
      if (curLogo) curLogo.classList.remove("is-active");
      if (nextLogo) nextLogo.classList.add("is-active");
    }

    // 先に次の動画を開始（クロスフェード中は両方再生）
    nxt.play().catch(() => {});

    // フェード完了後に前の動画のみ停止（currentTimeはリセットしない）
    if (stopTimer) clearTimeout(stopTimer);
    const prevRef = cur;
    stopTimer = setTimeout(() => {
      if (!prevRef.classList.contains("is-active")) {
        try {
          prevRef.pause();
        } catch (e) {
          /* noop */
        }
      }
    }, FADE_MS);
    idx = nextIdx;
  };

  let timer = setInterval(() => {
    switchTo((idx + 1) % vids.length);
  }, DURATION);

  // タブ非表示時は一時停止
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      clearInterval(timer);
      vids.forEach((v) => v.pause());
    } else {
      vids[idx].play().catch(() => {});
      timer = setInterval(() => {
        switchTo((idx + 1) % vids.length);
      }, DURATION);
    }
  });
});
